import { render } from "./TableOverlaySwipe.vue?vue&type=template&id=4efe86fb&scoped=true"
import script from "./TableOverlaySwipe.vue?vue&type=script&lang=js"
export * from "./TableOverlaySwipe.vue?vue&type=script&lang=js"

import "./TableOverlaySwipe.vue?vue&type=style&index=0&id=4efe86fb&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efe86fb"]])

export default __exports__